module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiBanner-fa127a249afb8157d75e308aa42745f1.png";